import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Card, CardBody } from 'reactstrap'
import classNames from 'classnames'

import s from './Card.module.scss'
import { TitleBlock } from './TitleBlock'
import { InfoBlock } from './InfoBlock'

export const ReceivedInviteCard = ({ data, className = 'mb-3', ...props }) => {
  const { t } = useTranslation()

  return (
    <Card
      className={classNames(s.root, {
        [className]: className,
      })}
    >
      <CardBody>
        <div className={s.topBar}>
          <div className={s.titleBlock}>
            <TitleBlock data={data} />
          </div>
        </div>

        <InfoBlock data={{ ...data }} />
      </CardBody>
    </Card>
  )
}

ReceivedInviteCard.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
}
